"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IccUserXApi = void 0;
const IccUserApi_1 = require("../icc-api/api/IccUserApi");
class IccUserXApi extends IccUserApi_1.IccUserApi {
    constructor(host, headers, fetchImpl = typeof window !== 'undefined'
        ? window.fetch
        : typeof self !== 'undefined'
            ? self.fetch
            : fetch) {
        super(host, headers, fetchImpl);
        this.fetchImpl = fetchImpl;
    }
}
exports.IccUserXApi = IccUserXApi;
//# sourceMappingURL=icc-user-x-api.js.map